module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-select', {
    attrs: {
      "items": _vm.campaignQuarterOptions,
      "item-text": "name",
      "item-value": "value",
      "label": "Campaign Qtr",
      "readonly": _vm.readonly,
      "hide-details": "auto",
      "dense": ""
    },
    on: {
      "input": function (val) { return _vm.$emit('updatedCampaignQuarter', val); }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-234da7b9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/createTarget/components/CampaignQuarterSelect.vue
// module id = 1840
// module chunks = 0